angular.module("vgresiduos").controller("ChecklistGridCtrl", [
	"$scope",
	"$state",
	"auditService",
	"$rootScope",
	"$q",
	"accountService",
	"httpService",
	function ($scope, $state, auditService, $rootScope, $q, accountService, httpService) {
		"use strict";

		// Local variables
		const currentClient = accountService.getCurrentClient();

		// Scope variables
		$scope.loadingAudits = false;
		$scope.filters = { onlyInternal: false, onlyActive: true };

		this.$onInit = function () {
			$scope.loadingAudits = true;

			loadGridOptions();
			loadAudits();
		};

		function loadGridOptions() {
			const columns = getGridColumns();

			$scope.gridOptions = {
				hasPermission: function () {
					return true;
				},
				columnDefinitions: columns,
				title: $rootScope.labels.CHECKLIST,
				query: {
					limit: 100,
					page: 1
				},
				data: [],

				rowClick: function (item) {
					goToAuditEditPage(item);
				},
				edit: function (item) {
					goToAuditEditPage(item);
				},

				promise: {},
				hasData: false,
				errorLoading: false,
				removeDelete: true,
				removeSearch: true,
				removeNew: true
			};

			$rootScope.contentNavBarGrid = $scope.gridOptions;
		}

		function getGridColumns() {
			return [
				{
					field: "organization.name",
					displayName: function () {
						return $rootScope.labels.CLIENT;
					}
				},
				{
					field: "userResponsible.name",
					displayName: function () {
						return $rootScope.labels.RESPONSIBLE;
					}
				},
				{
					field: "AuditDateString",
					displayName: function () {
						return $rootScope.labels.AUDIT_DATE;
					}
				},
				{
					field: "ClassificationDescription",
					displayName: function () {
						return $rootScope.labels.CLASSIFICATION;
					},
					iconClass: "align-icon",
					classes: "m-l-30",
					orderField: "classification",
					icon: {
						iconImageClass: "icon-resize",
						property: "ClassificationImg",
						condition: function (row) {
							return !!row.classification;
						}
					}
				},
				{
					field: "StatusDescription",
					displayName: function () {
						return $rootScope.labels.STATUS;
					}
				},
				{
					field: "LevelDescription",
					displayName: function () {
						return $rootScope.labels.LEVEL;
					}
				},
				{
					field: "ExpirationDateString",
					displayName: function () {
						return $rootScope.labels.EXPIRATION;
					}
				}
			];
		}

		function goToAuditEditPage(audit) {
			$state.go("editSupplierAudit", {
				supplierCode: currentClient.id,
				auditId: audit.id,
				supplierId: currentClient.id
			});
		}

		function loadAudits() {
			$scope.loadingAudits = true;

			const deferred = $q.defer();
			httpService.getListFromServiceCore(auditService.listAudits, {}).then(
				function (resp) {
					fillAuditList(resp.list);
					$scope.gridOptions.data = resp.list;
					$scope.loadingAudits = false;
					deferred.resolve();
				},
				function () {
					$scope.loadingAudits = false;
					deferred.reject();
				}
			);

			$scope.gridOptions.promise = deferred.promise;
		}

		function fillAuditList(auditList) {
			for (const audit of auditList) {
				audit.AuditDateString = Vgr.util.dateToString(new Date(audit.auditDate));
				audit.ExpirationDateString = Vgr.util.dateToString(new Date(audit.expirationDate));
				fillStatusInfo(audit);
				fillClassificationInfo(audit);
				fillLevelInfo(audit);
			}
		}

		function fillStatusInfo(audit) {
			switch (audit.status) {
				case Vgr.enumerations.audit.StatusText.Pending:
					audit.StatusDescription = $scope.labels.PENDING;
					break;
				case Vgr.enumerations.audit.StatusText.Valid:
					audit.StatusDescription = $scope.labels.VALID_AUDIT;
					break;
				case Vgr.enumerations.audit.StatusText.Canceled:
					audit.StatusDescription = $scope.labels.CANCELED_AUDIT;
					break;
				case Vgr.enumerations.audit.StatusText.Expired:
					audit.StatusDescription = $scope.labels.EXPIRED_AUDIT;
					break;
				case Vgr.enumerations.audit.StatusText.WaitingSupplier:
					audit.StatusDescription = $scope.labels.WAITING_SUPPLIER_AUDIT;
					break;
			}
		}

		function fillClassificationInfo(audit) {
			auditService.loadClientClassification(audit);
		}

		function fillLevelInfo(audit) {
			audit.LevelDescription = $rootScope.labels.LEVEL + " " + audit.level;
		}
	}
]);
